/**
 * @fileoverview Compare Table component
 *
 * This adds the compare functionality to the compare table used in mobile and tablet breakpoint
 */

import SelectorEngine from '../../utils/dom/selector-engine';
import { html, render } from 'lit-html';

class CompareTable {
	constructor(compareTableContainer) {
		this.compareTable = SelectorEngine.findOne('.js-compare-table__table', compareTableContainer);
		this.compareTableContainer = compareTableContainer;
		// compareData cames from a script tag in html head
		this._compareData = window[this.compareTable.dataset.compareData];
		this.selectedIndexLeft = '';
		this.selectedIndexRight = '';

		this.initCompareTable();
	}

	initCompareTable() {
		const leftSelect = SelectorEngine.findOne('select', this.compareTableContainer.querySelector('.js-select-compare-membership-left'));
		const rightSelect = SelectorEngine.findOne('select', this.compareTableContainer.querySelector('.js-select-compare-membership-right'));

		this.selectedIndexLeft = leftSelect.selectedIndex;
		this.selectedIndexRight = rightSelect.selectedIndex;
		let tpl = this.mobileTableTemplate({ data: this.tableData });
		render(tpl, SelectorEngine.findOne('.js-compare-table__table', this.compareTableContainer));

		leftSelect.addEventListener('change', () => {
			this.selectedIndexLeft = leftSelect.selectedIndex;

			tpl = this.mobileTableTemplate({ data: this.tableData });
			render(tpl, SelectorEngine.findOne('.js-compare-table__table', this.compareTableContainer));
		});

		rightSelect.addEventListener('change', () => {
			this.selectedIndexRight = rightSelect.selectedIndex;

			tpl = this.mobileTableTemplate({ data: this.tableData });
			render(tpl, SelectorEngine.findOne('.js-compare-table__table', this.compareTableContainer));
		});
	}


	mobileTableTemplate() {
		const leftPrice = this._compareData.Memberships[this.selectedIndexLeft].Price;
		const leftPricePeriod = this._compareData.Memberships[this.selectedIndexLeft].PricePeriod;
		const rightPrice = this._compareData.Memberships[this.selectedIndexRight].Price;
		const rightPricePeriod = this._compareData.Memberships[this.selectedIndexRight].PricePeriod;

		/* eslint-disable max-len */
		return html`
			<thead>
				<tr>
					<th>${this._compareData.Memberships[this.selectedIndexLeft].Name}</th>
					<th>${this._compareData.Memberships[this.selectedIndexRight].Name}</th>
				</tr>
			</thead>

			<tbody>
				<tr>
					<th colspan="2">Elegibility</th>
				</tr>
				<tr>
					<td>${this._compareData.Memberships[this.selectedIndexLeft].Eligibility}</td>
					<td>${this._compareData.Memberships[this.selectedIndexRight].Eligibility}</td>
				</tr>
			</tbody>

			<tbody>
				<tr>
					<th colspan="2">Price</th>
				</tr>
				<tr>
					<td>${leftPrice ? `£${leftPrice} / ${leftPricePeriod}` : 'FREE'}</td>
					<td>${rightPrice ? `£${rightPrice} / ${rightPricePeriod}` : 'FREE'}</td>
				</tr>
			</tbody>

			<tbody>
				<tr>
					<th colspan="2">Age</th>
				</tr>
				<tr>
					<td>${this._compareData.Memberships[this.selectedIndexLeft].AgeRestrictions ? this._compareData.Memberships[this.selectedIndexLeft].AgeRestrictions : 'All'}</td>
					<td>${this._compareData.Memberships[this.selectedIndexRight].AgeRestrictions ? this._compareData.Memberships[this.selectedIndexRight].AgeRestrictions : 'All'}</td>
				</tr>
			</tbody>

			${this._compareData.Benefit.map((benefitValues) => html`
				<tbody>
					<tr>
						<th colspan="2">${benefitValues.GroupTitle}</th>
					</tr>
					${Object.entries(benefitValues.Benefits).map((benefit) => {
		/*
		1. First I iterated Benefit array, these are the groups as Discounts, Compete, etc.
		2. Now I'm checking inside Benefits objects that has each benefit's id and name
		3. And I'm checking if Memberships has those benefits included. The way they are added is indicating it via an array of ids inside FullBenefits (e.g. [6, 8, 16]), so I check if the current id of the loop is present inside FullBenefits (e.g. FullBenefits.indexOf(6) // output -> 0) and then use that index in a ternary operator to add the benefit name.
		*/

		const id = 0;
		const name = 1;

		// this ternary operator it's here because if there are no benefits added the value of it is null. If always will be at least one benefit added it could be removed.
		const indexLeft = this._compareData.Memberships[this.selectedIndexLeft].FullBenefits ? this._compareData.Memberships[this.selectedIndexLeft].FullBenefits.indexOf(Number(benefit[id])) : -1;
		const indexRight = this._compareData.Memberships[this.selectedIndexRight].FullBenefits ? this._compareData.Memberships[this.selectedIndexRight].FullBenefits.indexOf(Number(benefit[id])) : -1;

		let benefitLeft = '-';
		let benefitRight = '-';

		// same as the ternary operator above but with an if
		if (this._compareData.Memberships[this.selectedIndexLeft].FullBenefits) {
			benefitLeft = this._compareData.Memberships[this.selectedIndexLeft].FullBenefits[indexLeft] ? benefit[name] : '-';
		}

		if (this._compareData.Memberships[this.selectedIndexRight].FullBenefits) {
			benefitRight = this._compareData.Memberships[this.selectedIndexRight].FullBenefits[indexRight] ? benefit[name] : '-';
		}

		return html`
							<tr>
								<td aria-label=${benefitLeft === '-' ? 'not included' : 'included'}>${benefitLeft}</td>
								<td aria-label=${benefitRight === '-' ? 'not included' : 'included'}>${benefitRight}</td>
							</tr>
						`;
	})}
				</tbody>
			`)}
		`;
		/* eslint-enable max-len */
	}

}

export default CompareTable;
